class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.focusItems = Array.from(this.querySelectorAll('[data-product-focus-btn]'));
    this.focusBlocks = Array.from(this.querySelectorAll('[data-product-focus-block]'));
    this.focusNav = this.querySelector('.product-focus__nav');
    this.currentActive = null; // Suivi du bouton actif
    this.header = document.querySelector('.header'); // Cache l'élément header pour éviter des recherches répétées
    this.scrollPending = false; // Flag pour savoir si une mise à jour est nécessaire
    this.descriptionLink = document.querySelector('a[data-description-link]');
    this.descriptionLinkValue = this.descriptionLink.dataset.descriptionLink;

    if (this.descriptionLink) {
      this.descriptionLink.addEventListener('click', (e) => {
        this.handleDescriptionLinkClick();
      });
    }
  }

  handleDescriptionLinkClick() {
  const targetBlock = this.focusBlocks.find(block => {
    let parent = block.parentElement;
    while (parent) {
      if (parent.id === this.descriptionLinkValue) {
        return true;
      }
      parent = parent.parentElement;
    }
    return false;
  });

  if (targetBlock) {
    targetBlock.setAttribute('open', '');

    const summary = targetBlock.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }
  }
}

  connectedCallback() {
    if (!this.focusItems.length || !this.focusBlocks.length || !this.focusNav) return;
    this.initTabNavigation();
    this.initStickyNav();
  }

  // Initialise les boutons de navigation pour les blocs
  initTabNavigation() {
    this.focusItems.forEach(item =>

        item.addEventListener('click', () => this.activateTab(item))
    );
  }

  // Active un onglet et fait défiler jusqu'au bloc correspondant
  activateTab(item) {
    const targetId = item.dataset.productFocusBtn;

    this.updateActiveButton(item);
    this.updateActiveBlock(targetId);
  }

  // Gère l'état actif des boutons
  updateActiveButton(activeItem) {
    if (this.currentActive === activeItem) return;
    this.focusItems.forEach(btn => btn.classList.toggle('active', btn === activeItem));
    this.currentActive = activeItem;
  }

  // Affiche le bloc correspondant et fait défiler jusqu'à lui
  updateActiveBlock(targetId) {
    const focusNavHeight = this.focusNav.offsetHeight;
    const headerHeight = this.header.clientHeight;
    const totalOffset = focusNavHeight + headerHeight;

    this.focusBlocks.forEach(block => {
      const isTarget = block.dataset.productFocusBlock === targetId;
      block.toggleAttribute('open', isTarget);
      if (isTarget) {
        const blockTop = block.getBoundingClientRect().top + window.scrollY + 5;
        const scrollToPosition = blockTop - totalOffset; // Position avec décalage
        window.scrollTo({
          top: scrollToPosition, // Décalage vers le haut pour ajuster la position
          behavior: 'smooth',
        });
      }
    });
  }

  // Initialise la navigation sticky et le suivi de défilement
  initStickyNav() {
    let ticking = false;

    const updatePosition = () => {
      this.focusNav.style.top = `${this.header.clientHeight}px`;
      this.toggleScrollTracking();
    };

    const onScrollOrResize = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          updatePosition();
          ticking = false;
        });
      }
    };

    window.addEventListener('scroll', onScrollOrResize);
    window.addEventListener('resize', onScrollOrResize);
    updatePosition(); // Assure l'initialisation correcte au chargement
  }

  // Vérifie si la navigation est sticky
  isFocusNavSticky() {
    const rect = this.focusNav.getBoundingClientRect();
    return rect.top <= this.header.clientHeight;
  }

  // Active ou désactive le suivi de défilement
  toggleScrollTracking() {
    if (this.isFocusNavSticky()) {
      this.enableScrollTracking();
    } else {
      this.disableScrollTracking();
    }
  }

  // Active le suivi de défilement
  enableScrollTracking() {
    if (this.scrollTrackingEnabled) return;
    this.scrollTrackingEnabled = true;
    window.addEventListener('scroll', this.scheduleScrollTracking);
  }

  // Désactive le suivi de défilement
  disableScrollTracking() {
    if (!this.scrollTrackingEnabled) return;
    this.scrollTrackingEnabled = false;
    window.removeEventListener('scroll', this.scheduleScrollTracking);
  }

  // Planifie l'exécution de trackScroll avec requestAnimationFrame
  scheduleScrollTracking = () => {
    if (!this.scrollPending) {
      this.scrollPending = true;
      requestAnimationFrame(this.trackScroll);
    }
  };

  // Suivi du défilement pour activer le bon bouton
  trackScroll = () => {
    this.scrollPending = false;

    const focusNavBottom = this.header.clientHeight + this.focusNav.offsetHeight;

    const activeBlock = this.focusBlocks.find(block => {
      const rect = block.getBoundingClientRect();
      return rect.top < focusNavBottom && rect.bottom > focusNavBottom;
    });

    if (activeBlock) {
      const targetId = activeBlock.dataset.productFocusBlock;
      const activeButton = this.focusItems.find(
          btn => btn.dataset.productFocusBtn === targetId
      );
      this.updateActiveButton(activeButton);
    }
  };
}

customElements.get('collapsible-content') || customElements.define('collapsible-content', CollapsibleContent);